/* VISTA /stock . 
Muestra el stock del evento y permite su creacion. */
import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { api } from "../../services/api";
import { toast } from 'react-toastify';

import StockTab from "../../components/VentaPresencial/CajaYStock/StockTab";

const Stock = () => {
  const { id } = useParams();
  const [vendedores, setVendedores] = useState([]);
  const [allTarifas, setAllTarifas] = useState([]);

  const [allStock, setAllStock] = useState([]);
  const [loadingStock, setLoadingStock] = useState(true);

  const fetchAllStock = async () => {
    setLoadingStock(true);
    const res = await api.stock.getAllStock(id);
    if (res.status === 'success') {
      setAllStock(res.data);
    }
    setLoadingStock(false);
  };

  useEffect(() => {
    const fetchVendedores = async () => {
      const res = await api.vendedores.getVendedores(id, '');
      if (res.status === 'success') {
        const vendedoresUnicos = [];
        const idsUsados = new Set();
        const emailsUsados = new Set();

        res.data?.forEach(v => {
          if (!idsUsados.has(v.id) && !emailsUsados.has(v.email)) {
            vendedoresUnicos.push({
              id: v.id,
              nombre: v.nombre || '',
              apellido: v.apellido || '',
              email: v.email || '',
              caja: v.caja || ''
            });
            idsUsados.add(v.id);
            emailsUsados.add(v.email);
          }
        });
        setVendedores(vendedoresUnicos);
      }
    };

    const fetchAllTarifas = async () => {
      const res = await api.tarifas.getTarifaByEventoWithoutPagination(id);
      if (res.status === 'success') setAllTarifas(res.data?.tarifas ?? []);
    };

    fetchVendedores();
    fetchAllTarifas();
    fetchAllStock();
  }, [id]);

  const showSuccess = (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
    });
  };

  const showError = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 4000,
    });
  };

  return (
    <Container maxWidth="md" sx={{ mt: 2 }}>
      <StockTab
        eventoId={id}
        allTarifas={allTarifas}
        allStock={allStock}
        loadingStock={loadingStock}
        refetchStock={fetchAllStock}
        onSuccess={showSuccess}
        onError={showError}
      />
    </Container>
  );
};

export default Stock;